
import {defineComponent} from "vue";
import {ArrowLeftOutlined, HolderOutlined, CheckSquareOutlined, WarningOutlined} from '@ant-design/icons-vue';

interface DataInt {
  books: any[],
  bookToTransfer: string,
  draggedParent: any,
}

export default defineComponent({
  name: "BooksPage",
  components: {
    ArrowLeftOutlined,
    HolderOutlined,
    CheckSquareOutlined,
    WarningOutlined,
  },
  data(): DataInt {
    return {
      books: [
        {id: 1, name: "book1", type: "falk"},
        {id: 2, name: "book2", type: "falk"},
        {id: 3, name: "book3", type: "idk"},
        {id: 4, name: "book4", type: "falk"},
        {id: 5, name: "book5", type: "idk"},
        {id: 6, name: "book6", type: "idk"},
      ],
      bookToTransfer: "",
      draggedParent: null,
    }
  },
  methods: {
    allowDrop(e: any) {
      e.preventDefault();
    },
    dragItem(e: any) {
      e.dataTransfer.setData("text", e.target.id)
      this.bookToTransfer = e.dataTransfer.getData("text")
      this.draggedParent = e.target.parentElement
    },
    dragItemDisStyle() {
      if (this.draggedParent) {
        this.draggedParent.classList.remove("nested")
      }
    },
    dropItem(e: any) {
      e.preventDefault();
      if (
          e.target === this.draggedParent
          ||
          e.target.children.length > 0
      ) {
        return
      } else {
        e.target.appendChild(document.getElementById(this.bookToTransfer))
        e.currentTarget.classList.add("nested")
        this.dragItemDisStyle()
      }
    },
    checkBooks() {
      let falkList = document.getElementsByClassName("falk-list")
      let idkList = document.getElementsByClassName("idk-list")

      let falkBooks = document.getElementsByClassName("falk")
      let idkBooks = document.getElementsByClassName("idk")

      /*console.log(falkList.length) // ,method for array
      for (let list = 0; list < falkList.length; list++) {
        console.log(falkList[list])
        if (falkList[list].hasChildNodes()) {
          console.log(`child`)
          if (falkList[list].children[0].classList.value.indexOf("falk") !== -1) {
            console.log("ok")
            falkList[list].classList.add("ok")
          } else {
            console.log("bad")
            falkList[list].classList.add("bad")
          }
        }
      }*/

      for (let book = 0; book < falkBooks.length; book++) {
        console.log(falkList[book])
        if (falkBooks[book].classList.value.indexOf("ok") !== -1) {
          falkBooks[book].classList.remove("ok")
        }
        if (falkBooks[book].classList.value.indexOf("bad") !== -1) {
          falkBooks[book].classList.remove("bad")
        }
        if (falkBooks[book].parentElement!.classList.value.indexOf("falk-list") !== -1) {
          console.log("ok")
          falkBooks[book].classList.add("ok")
        } else {
          console.log("bad")
          falkBooks[book].classList.add("bad")
        }
      }

      for (let book = 0; book < idkBooks.length; book++) {
        console.log(idkBooks[book])
        if (idkBooks[book].classList.value.indexOf("ok") !== -1) {
          idkBooks[book].classList.remove("ok")
        }
        if (idkBooks[book].classList.value.indexOf("bad") !== -1) {
          idkBooks[book].classList.remove("bad")
        }
        if (idkBooks[book].parentElement!.classList.value.indexOf("idk-list") !== -1) {
          console.log("ok")
          idkBooks[book].classList.add("ok")
        } else {
          console.log("bad")
          idkBooks[book].classList.add("bad")
        }
      }
    }
  }
})
